import { render } from "./SVGIcon.vue?vue&type=template&id=4af9646a"
import script from "./SVGIcon.vue?vue&type=script&lang=js"
export * from "./SVGIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__